import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'

@Component({
  selector: 'ddc-ad-carousel',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './ddc-ad-carousel.component.html',
  styleUrl: './ddc-ad-carousel.component.scss',
})
export class DdcAdCarouselComponent {
  currentIndex = 0

  next(): void {
    if (this.currentIndex < this.features.length - 1) this.currentIndex++
  }

  prev(): void {
    if (this.currentIndex > 0) this.currentIndex--
  }

  goTo(index: number): void {
    this.currentIndex = index
  }
  features = [
    {
      title: 'Personalized Learning',
      description: 'Create and customize your own dictionaries with ease.',
      image: 'https://daydic.com/media/screens/New-I-1.png',
    },
    {
      title: 'Be Social',
      description: 'Share your dictionaries and connect with fellow learners.',
      image: 'https://daydic.com/media/screens/New-I-2.png',
    },
    {
      title: 'Try Lingo AI',
      description: 'Get personalized learning assistance with our AI-Agent.',
      image: 'https://daydic.com/media/screens/New-I-3.png',
    },
    {
      title: 'Ask Anything',
      description: 'Lingo AI answers your questions instantly.',
      image: 'https://daydic.com/media/screens/New-I-4.png',
    },
    {
      title: 'Travel Mode',
      description: 'Learn on the go, learn any language anywhere.',
      image: 'https://daydic.com/media/screens/New-I-5.png',
    },
    {
      title: 'Add Words and Pairs',
      description: 'Expand your dictionaries with new words and translations.',
      image: 'https://daydic.com/media/screens/New-I-6.png',
    },
    {
      title: 'Flashcards',
      description: 'Play engaging games to reinforce your learning.',
      image: 'https://daydic.com/media/screens/New-I-7.png',
    },
    {
      title: 'Matching Games',
      description: 'Engage in fun and interactive matching games to boost your memory.',
      image: 'https://daydic.com/media/screens/New-I-8.png',
    },
    {
      title: 'Be Organized',
      description: 'Keep your learning materials neatly arranged and easily accessible.',
      image: 'https://daydic.com/media/screens/New-I-9.png',
    },
  ]
}
